import { ACCOUNT_PARAM } from '#pplx/frontend/account-navigation/constants.js';
import { getActiveAccountId } from '#pplx/frontend/browser-storage/activeAccount.js';
import { isDocumentInForeground, recordLastActiveAccount, } from '#pplx/frontend/browser-storage/lastActiveAccount.js';
import { getWindowOrigin } from '#pplx/frontend/common/location.js';
import { validateUuid } from '#pplx/frontend/common/validateUuid.js';
/**
 * Binds a same-origin document navigation to an authenticated account. The server treats the
 * selector only as a request to choose among the sessions already present in the request cookies.
 */
export function bindDocumentNavigationToAccount(path, accountId, currentOrigin) {
    if (accountId === null || !validateUuid(accountId) || !currentOrigin) {
        return path;
    }
    let target;
    try {
        target = new URL(path, currentOrigin);
    }
    catch {
        return path;
    }
    if (target.origin !== currentOrigin || target.searchParams.has(ACCOUNT_PARAM)) {
        return path;
    }
    target.searchParams.set(ACCOUNT_PARAM, accountId);
    // Native browser handoffs require absolute URLs to stay absolute.
    return /^[a-z][a-z\d+.-]*:/i.test(path.trimStart())
        ? target.toString()
        : `${target.pathname}${target.search}${target.hash}`;
}
/** Binds a document navigation using the active account and origin for this browser tab. */
export function bindDocumentNavigationToActiveAccount(path) {
    if (typeof window === 'undefined') {
        return path;
    }
    return bindDocumentNavigationToAccount(path, getActiveAccountId(), getWindowOrigin({ intent: 'document' }));
}
/**
 * Bind a document navigation only when the initiating document is not in the foreground.
 * Foreground navigations inherit the browser-wide last-active cookie, but that default may belong
 * to another tab or window when an async operation completes in the background.
 */
export function bindDocumentNavigationToActiveAccountWhenBackgrounded(path) {
    if (typeof document === 'undefined') {
        return path;
    }
    if (isDocumentInForeground(document)) {
        // Keep auxiliary SPAs, which do not install focus tracking, aligned with the server default.
        recordLastActiveAccount();
        return path;
    }
    return bindDocumentNavigationToActiveAccount(path);
}
//# sourceMappingURL=accountNavigation.js.map